/* eslint-disable react-hooks/exhaustive-deps */

import React, {
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  forwardRef
} from 'react'
import { Button, Form, Image } from 'react-bootstrap'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { api_gateway } from '../conexoes/api'
import { getArrsAcoesRelatorios } from '../mostrarAcoes'
import { desabilitarAcoesCliente } from '../redux/actions'
import {
  conciliacaoEmLote,
  confimarRecebimentoVirtueyes,
  exportarLinhas,
  exportarLinhasDesbloqueioCiclo,
  exportarLinhasOperadora,
  exportarOperadora,
  exportarRelatorioSiga,
  limparFiltroPorArquivoFatSolicitacao,
  novaSolicitacaoVirtueyes,
  reenviarEmailVirtueyes,
  revelarAbrirTelaConciliacao,
  revelarAdicionarLogin,
  revelarAdicionarPacoteExtra,
  revelarAlteracaoprazodepermanenciaFaturas,
  revelarAlterarGrupo,
  revelarAlterarICCIDFaturas,
  revelarAlterarPlanoValor,
  revelarAlterarPrazoPermanencia,
  revelarAlterarciclodevidaFaturas,
  revelarAlterarcontaFaturas,
  revelarAlterarplanoFaturas,
  revelarAssociarFatura,
  revelarAtivarDemonstracao,
  revelarAtivarLinha,
  revelarAtivarLinhasAWS,
  revelarAtribuirLinhas,
  revelarAtualizarConciliacao,
  revelarAtualizarSms,
  revelarBloquearSms,
  revelarBloquearTemporariamento,
  revelarBloquearUso,
  revelarCadastrarFatura,
  revelarCadastrarUsuario,
  revelarCadastroCliente,
  revelarCadastroClienteCarregar,
  revelarCadastroClienteEditar,
  revelarCadastroClienteExcluir,
  revelarCadastroClienteNovo,
  revelarCadastroClienteVirtueyes,
  revelarCancelamento,
  revelarCancelamentoDeConta,
  revelarCancelamentoReposicao,
  revelarCancelarPedido,
  revelarConcluirPedido,
  revelarConfigurarGrupo,
  revelarConsultarSimcard,
  revelarContestarFatura,
  revelarCriarContaSms,
  revelarDeletarFatura,
  revelarDeletarPedidoImportado,
  revelarDesabilitarRegra,
  revelarDesativarDemonstracao,
  revelarDesativarSMSFaturas,
  revelarDesatribuirLinhas,
  revelarDesbloquearUso,
  revelarDesbloqueioCiclo,
  revelarDesbloqueioPermanente,
  revelarDispositivosAlterarCicloDeVida,
  revelarDispositivosAlterarConta,
  revelarDispositivosAlterarIccid,
  revelarDispositivosAlterarPlano,
  revelarDispositivosAlterarServicos,
  revelarDoppelgangerCliente,
  revelarDownloadBoleto,
  revelarDownloadRelatorio,
  revelarEdicaoUsuario,
  revelarEditarCicloVida,
  revelarEditarCliente,
  revelarEditarConta,
  revelarEditarElemento,
  revelarEditarEmpresa,
  revelarEditarFatPedidos,
  revelarEditarFatura,
  revelarEditarFornecedor,
  revelarEditarMenu,
  revelarEditarModulo,
  revelarEditarOperadora,
  revelarEditarPerfil,
  revelarEditarPlano,
  revelarEditarRegra,
  revelarEditarServico,
  revelarEditarSistema,
  revelarEditarSolicitacao,
  revelarEditarTela,
  revelarEditarTemplateSms,
  revelarEditarUsuario,
  revelarEnviarSms,
  revelarEnviarSmsModulo,
  revelarExcluirCicloVida,
  revelarExcluirCliente,
  revelarExcluirConta,
  revelarExcluirElemento,
  revelarExcluirEmpresa,
  revelarExcluirFatPedidos,
  revelarExcluirFatura,
  revelarExcluirFebraban,
  revelarExcluirFornecedor,
  revelarExcluirMenu,
  revelarExcluirModulo,
  revelarExcluirOperadora,
  revelarExcluirPerfil,
  revelarExcluirPlano,
  revelarExcluirRegra,
  revelarExcluirServico,
  revelarExcluirSistema,
  revelarExcluirSolicitacao,
  revelarExcluirTela,
  revelarExcluirTemplateSms,
  revelarExcluirUsuario,
  revelarExcluirUsuarioCliente,
  revelarExportarDetalhamento,
  revelarExportarDetalhamentoFinanceiro,
  revelarFalhaNaOperadora,
  revelarFiltrarSolicitacaoPorArquivo,
  revelarGerarRelatorio,
  revelarGerarRelatorios,
  revelarHabilitarRegra,
  revelarHistoricoAcessos,
  revelarImportarClientesUsuarios,
  revelarImportarDescricao,
  revelarImportarFebrabans,
  revelarIotTelecom,
  revelarLiberarSMSFaturas,
  revelarLiberarSms,
  revelarLogReset,
  revelarMapa,
  revelarMostrarEmDispositivos,
  revelarMostrarEmDispositivosSolicitacao,
  revelarNovaConta,
  revelarNovaEmpresa,
  revelarNovaMensagem,
  revelarNovaOperadora,
  revelarNovaRegra,
  revelarNovoCicloVida,
  revelarNovoCliente,
  revelarNovoElemento,
  revelarNovoFatPedidos,
  revelarNovoFornecedor,
  revelarNovoMenu,
  revelarNovoModulo,
  revelarNovoPedidoImportado,
  revelarNovoPedidoSMS,
  revelarNovoPedidoSimcard,
  revelarNovoPedidoSmsVirtueyes,
  revelarNovoPerfil,
  revelarNovoPlano,
  revelarNovoRelease,
  revelarNovoServico,
  revelarNovoSistema,
  revelarNovoTela,
  revelarNovoTemplateSms,
  revelarNovoUsuario,
  revelarNovoUsuarioCliente,
  revelarProcessarPedido,
  revelarRealocacao,
  revelarReativarLinha,
  revelarRecalcularFatura,
  revelarRecalcularFaturaConta,
  revelarRecalcularFaturaEmpresa,
  revelarRecalcularFaturaReferencia,
  revelarReenviarLinkPrimeiroAcessoUsuarioCliente,
  revelarReenviarSolicitacaoFaturas,
  revelarRelatorioConciliacao,
  revelarRelatorioConsumo,
  revelarRelatorioDisponibilidade,
  revelarRelatorioEnvioSms,
  revelarRelatorioFatura,
  revelarRelatorioFaturaDispositivos,
  revelarRelatorioFebraban,
  revelarRelatorioLinhasAfetadas,
  revelarRelatorioNotaFiscalGeral,
  revelarRelatorioPreviewFatura,
  revelarRelatorioResumoFebraban,
  revelarRemoverBloqueioTemporario,
  revelarRemoverContaSms,
  revelarRenegociarContrato,
  revelarReset,
  revelarResetFaturas,
  revelarSolicitacaBloquearVirtueyes,
  revelarSolicitacaEnviarAvisoVirtueyes,
  revelarSolicitacaExportarVirtueyes,
  revelarSolicitacaRemoverBloqueioVirtueyes,
  revelarSuporteTecnico,
  revelarSuspenderLinha,
  revelarTesteConexao,
  revelarTransferirLinhaClienteFinal,
  revelarTrocaDeTitularidade,
  revelarVerConversasSms,
  solicitacaCancelarVirtueyes,
  solicitacaConcluirVirtueyes,
  solicitacaReenviarProtocoloVirtueyes,
  solicitacaReenviarTrocaOcorrenciaVirtueyes
} from '../redux/actions/index'
import { ESimsService } from '../services/http/eSims.service.js'
import { useGlobal } from '../stores/useGlobal.js'
import { setaDropdown } from '../utils/alternanciaIcones'
import { isPortal } from '../utils/nivelCliente'
import { validadorPermissaoElemento } from '../utils/verificadorPermissaoElemento'

import ColetaClickstream from './clickstreamAnalise/clickstreamColeta.js'
import Loader from './Mantine/Loader'

const relatoriosZustand = [
  'exportarLinhasSimcardsEmBranco',
  'exportarSolicitacaoSimcardsEmBranco',
  'exportarDetalhamentoPortadora',
  'exportarHistoricoConexoesPortadoras',
  'exportarHistoricoConsumoPortadoras',
  'exportarLinhasPortadora',
  'exportarSolicitacoesESim',
  'exportarDetalhamentoESim',
  'exportarDetalhamentoDispositivosESim',
  'exportarPerfis',
  'exportarESims'
]

const acoesZustand = [
  'revelarNovoPedidoSimcardsEmBranco',
  'revelarMostrarEmDispositivosSimcardsEmBranco',
  'revelarMostrarEmDispositivosSolicitacoesSimcardsEmBranco',
  'revelarMostrarProvisionamentoSimcardsEmBranco',
  'revelarMostrarNoMapaPortadora',
  'revelarMapaDeCalorPortadora',
  'revelarMostrarEmPortadoras',
  'revelarVerificarWhatsapp',
  'revelarBloqueioPorConsumoPercentual',
  'revelarBaixarPerfil',
  'revelarRemoverPerfil',
  'revelarTrocarPerfil',
  'revelarTrocarOferta',
  'revelarAtivarESims',
  'revelarCancelarEsim',
  'revelarCancelarPerfilFabrica',
  'revelarImportESims',
  'revelarImportProfile',
  'revelarCancelamento',
  'revelarReciclagem',
  'revelarRealocacao',
  'revelarMostrarEmDispositivosESimDevices',
  'revelarAlterarClassificacaoDeRede',
  'revelarAdicionarLocalizacao',
  'revelarDestravarImei',
  'revelarDesabilitarSiga',
  'revelarHabilitarSiga'
]

const CACHE_5_MINUTOS = 5 * 60 * 1000

const ACOES_TELA_CADASTRO_PARCEIROS = [
  {
    cd_pav_acao: 92,
    cd_pav_acao_superior: 1,
    ds_acao: 'Editar',
    ds_acao_redux: 'revelarEditarCliente',
    ds_rota_permissao: '',
    fl_filho: 0,
    fl_relatorio: 0,
    fl_selecionado: 0
  },
  {
    cd_pav_acao: 93,
    cd_pav_acao_superior: 1,
    ds_acao: 'Excluir',
    ds_acao_redux: 'revelarExcluirCliente',
    ds_rota_permissao: '',
    fl_filho: 0,
    fl_relatorio: 0,
    fl_selecionado: 0
  },
  {
    cd_pav_acao: 91,
    cd_pav_acao_superior: 1,
    ds_acao: 'Novo',
    ds_acao_redux: 'revelarNovoCliente',
    ds_rota_permissao: '',
    fl_filho: 0,
    fl_relatorio: 0,
    fl_selecionado: 1
  }
]

const ACOES_FATURAS_EXCLUIDAS = [
  'revelarAtivacaoFaturas',
  'revelarBloqueioFuncionalFaturas',
  'revelarBloqueiotemporarioFaturas',
  'revelarDesbloqueiotemporarioFaturas',
  'revelarDesbloqueiofuncionalFaturas'
]

const fetchAcoesNivel1 = async (manejador) => {
  const response = await api_gateway.get(
    `/m1/consultar/acao?pa.n0_relevancia=1&pat.ds_acao=${manejador}`
  )
  return response.data
}

const fetchAcoesNivel2 = async (manejador) => {
  const response = await api_gateway.get(
    `/m1/consultar/acao?pa.n0_relevancia=2&pat.ds_acao=${manejador}`
  )
  return response.data
}

const fetchAcoesFaturas = async () => {
  const response = await api_gateway.get('/api/v2/acoes?modulo=fat')
  return response.data
}

const DropAcoes = forwardRef((props, ref) => {
  const {
    setExportarRelatorio,
    setMostrarAcao,
    setConfirmacaoAcao,
    linhasSelecionadas,
    selecionarParqueInteiro,
    setMostrarNotificacao,
    removerAcao,
    acaoParaExecutar,
    setAcaoParaExecutar
  } = useGlobal()

  const { getHasESimOnDevices } = ESimsService

  const [renderizar, setRenderizar] = useState(false)
  const [acoes, setAcoes] = useState([])
  const [mainAcoes, setMainAcoes] = useState([])
  const [subAcoes, setSubAcoes] = useState([])
  const [mainRelatorios, setMainRelatorios] = useState([])
  const [subRelatorios, setSubRelatorios] = useState([])
  const [isProcessing, setIsProcessing] = useState(true)
  const modal = useRef()
  const isMountedRef = useRef(true)

  const location = useLocation()
  const despacho = useDispatch()
  const portalCliente = isPortal()

  const manejador = useSelector((state) => state.manejadorState.manejador)
  const reduxModoSelecaoSimcard = useSelector(
    (state) => state.manejadorState.modoSelecaoSimcard
  )
  const desabilitarAcoes = useSelector(
    (state) => state.manejadorState.desabilitarAcoes
  )
  const tempdesabilitarAcoesCliente = useSelector(
    (state) => state.virtueyesState.desabilitarAcoesCliente
  )
  const esconderMenuAcoesDispositivosBloqueio = useSelector(
    (state) => state.manejadorState.esconderAcoesDispositivosClientes
  )
  const desabilitarAcoesEditar = useSelector(
    (state) => state.virtueyesState.desabilitarEditar
  )
  let limparFiltroPorArquivo = useSelector(
    (state) => state.faturasState.limparFiltroPorArquivoFatSolicitacao
  )

  const permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )

  const tituloAcoes = props.titulo === 'Ações'

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    setIsProcessing(true)
    setMainAcoes([])
    setSubAcoes([])
    setMainRelatorios([])
    setSubRelatorios([])
  }, [manejador, location.pathname])

  // Query para ações de faturas
  const queryFaturas = useQuery(
    ['acoes-faturas', manejador, location.pathname],
    fetchAcoesFaturas,
    {
      enabled: manejador === 'fatDispositivos',
      staleTime: CACHE_5_MINUTOS,
      onError: () => {
        despacho(desabilitarAcoesCliente(false))
        props.toggleRevelarDropAcoes(false)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  // Query para ações nível 1
  const queryAcoesNivel1 = useQuery(
    ['acoes-nivel1', manejador, location.pathname],
    () => fetchAcoesNivel1(manejador),
    {
      enabled: !!manejador && manejador !== 'fatDispositivos',
      staleTime: CACHE_5_MINUTOS,
      onError: () => {
        despacho(desabilitarAcoesCliente(false))
        props.toggleRevelarDropAcoes(false)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  // Query para ações nível 2
  const queryAcoesNivel2 = useQuery(
    ['acoes-nivel2', manejador, location.pathname],
    () => fetchAcoesNivel2(manejador),
    {
      enabled: !!manejador && manejador !== 'fatDispositivos',
      staleTime: CACHE_5_MINUTOS,
      onError: () => {
        despacho(desabilitarAcoesCliente(false))
        props.toggleRevelarDropAcoes(false)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  // Processa dados de faturas
  useEffect(() => {
    if (!queryFaturas.data) return

    const data = queryFaturas.data
    const acoesRelatoriosFaturas = data.dropRelatorios || []
    let mainAcoesFaturas = (data.dropAcoes || []).map((item) => {
      let stringRedux = 'revelar' + item.ds_nome.replace(/\s/g, '') + 'Faturas'
      item.ds_acao_redux = stringRedux
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

      item.ds_acao = item.ds_nome
      item.fl_filho = 0
      item.fl_relatorio = 0

      if (
        item.ds_acao_redux === 'revelarAlterarciclodevidaFaturas' ||
        item.ds_acao_redux === 'revelarAlterarICCIDFaturas'
      ) {
        item.fl_selecionado = 1
      } else {
        item.fl_selecionado = 0
      }

      return item
    })

    mainAcoesFaturas = mainAcoesFaturas?.filter((item) => {
      return !ACOES_FATURAS_EXCLUIDAS.includes(item.ds_acao_redux)
    })

    if (isMountedRef.current) {
      setMainRelatorios(acoesRelatoriosFaturas)
      setMainAcoes(mainAcoesFaturas)
      setIsProcessing(false)
    }
  }, [queryFaturas.data, manejador])

  // Processa ações de nível 1
  useEffect(() => {
    const processarAcoesNivel1 = async () => {
      const response = queryAcoesNivel1.data
      if (!response || response.status !== 200) return

      let dados = response.dados

      // TODO refazer essa gambiarra, cadastrar as açoes no banco
      if (manejador === 'cadastroParceiro') {
        dados = ACOES_TELA_CADASTRO_PARCEIROS
      }

      let [arrAcoes, arrRelatorios] = await getArrsAcoesRelatorios({
        dados,
        manejador,
        portalCliente
      })

      if (desabilitarAcoesEditar) {
        arrAcoes = arrAcoes.filter((item) => item.ds_acao !== 'Editar')
      }

      if (removerAcao?.length) {
        arrAcoes = arrAcoes.filter((item) => {
          return !removerAcao.some(
            (filter) =>
              Object.keys(filter).includes(item.ds_acao_redux) &&
              filter[item.ds_acao_redux]
          )
        })
      }

      if (isMountedRef.current) {
        setMainRelatorios(arrRelatorios)
        setMainAcoes(arrAcoes)
        setIsProcessing(false)
      }
    }

    processarAcoesNivel1()
  }, [queryAcoesNivel1.data, manejador, desabilitarAcoesEditar, removerAcao])

  // Processa ações de nível 2
  useEffect(() => {
    const processarAcoesNivel2 = async () => {
      const response = queryAcoesNivel2.data
      if (!response || response.status !== 200) return

      const [arrAcoes, arrRelatorios] = await getArrsAcoesRelatorios({
        dados: response.dados,
        manejador,
        portalCliente
      })
      if (isMountedRef.current) {
        setSubRelatorios(arrRelatorios)
        setSubAcoes(arrAcoes)
        setIsProcessing(false)
      }
    }

    processarAcoesNivel2()
  }, [queryAcoesNivel2.data, manejador])

  const currentMainAcoes = tituloAcoes ? mainAcoes : mainRelatorios
  const currentSubAcoes = tituloAcoes ? subAcoes : subRelatorios

  const spinAtivo =
    isProcessing ||
    queryFaturas.isFetching ||
    queryAcoesNivel1.isFetching ||
    queryAcoesNivel2.isFetching

  const handleClickFora = (e) => {
    ColetaClickstream(209) // 'dropAcoesHandleClickFora'
    const botaoAcoesOuRelatorios = document.querySelector(
      'form.drop-acoes-container'
    )
    if (
      !modal.current?.contains(e.target) ||
      (props.titulo === 'Relatórios' && e.target == botaoAcoesOuRelatorios)
    ) {
      props.toggleRevelarDropAcoes(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [])

  useEffect(() => {
    renderAcoes()
  }, [renderizar, currentMainAcoes])

  useEffect(() => {
    if (acaoParaExecutar) {
      handleDespacho(acaoParaExecutar)
      setAcaoParaExecutar(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acaoParaExecutar])

  useImperativeHandle(ref, () => ({
    executarAcao: (acaoRedux) => {
      handleDespacho(acaoRedux)
    }
  }))

  async function renderSubAcoes(cd_pav_acao) {
    return Promise.all(
      currentSubAcoes
        .filter((subMenu) => subMenu.cd_pav_acao_superior == cd_pav_acao)
        .map(async (subMenu, i) => {
          if (subMenu.fl_selecionado == 1) {
            if (!desabilitarAcoes) {
              if (subMenu.ds_rota_permissao) {
                if (
                  await validadorPermissaoElemento(
                    permissaoElemento,
                    subMenu.ds_rota_permissao
                  )
                ) {
                  return (
                    <li key={'subMenu-' + subMenu.cd_pav_acao}>
                      <div
                        className="drop-acoes-submenu item-drop-acoes-hover"
                        onClick={() =>
                          handleDespacho(subMenu.ds_acao_redux, subMenu)
                        }
                      >
                        <span className="drop-acoes-submenu-label fonte-cor-1">
                          {subMenu.ds_acao}
                        </span>
                      </div>
                      {currentSubAcoes[i + 1] != undefined && (
                        <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                      )}
                    </li>
                  )
                }
              } else {
                return (
                  <li key={'subMenu-' + subMenu.cd_pav_acao}>
                    <div
                      className="drop-acoes-submenu item-drop-acoes-hover"
                      onClick={() =>
                        handleDespacho(subMenu.ds_acao_redux, subMenu)
                      }
                    >
                      <span className="drop-acoes-submenu-label fonte-cor-1">
                        {subMenu.ds_acao}
                      </span>
                    </div>
                    {currentSubAcoes[i + 1] != undefined && (
                      <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                    )}
                  </li>
                )
              }
            }
          } else {
            if (subMenu.ds_rota_permissao) {
              if (
                await validadorPermissaoElemento(
                  permissaoElemento,
                  subMenu.ds_rota_permissao
                )
              ) {
                return (
                  <li key={'subMenu-' + subMenu.cd_pav_acao}>
                    <div
                      className="drop-acoes-submenu item-drop-acoes-hover"
                      onClick={() =>
                        handleDespacho(subMenu.ds_acao_redux, subMenu)
                      }
                    >
                      <span className="drop-acoes-submenu-label fonte-cor-1">
                        {subMenu.ds_acao}
                      </span>
                    </div>
                    {currentSubAcoes[i + 1] != undefined && (
                      <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                    )}
                  </li>
                )
              }
            } else {
              return (
                <li key={'subMenu-' + subMenu.cd_pav_acao}>
                  <div
                    className="drop-acoes-submenu item-drop-acoes-hover"
                    onClick={() =>
                      handleDespacho(subMenu.ds_acao_redux, subMenu)
                    }
                  >
                    <span className="drop-acoes-submenu-label fonte-cor-1">
                      {subMenu.ds_acao}
                    </span>
                  </div>
                  {(currentSubAcoes[i + 1] != undefined ||
                    subMenu.ds_acao_redux ===
                      'revelarRecalcularFaturaEmpresa') && (
                    <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                  )}
                </li>
              )
            }
          }
        })
    )
  }

  async function renderAcoes() {
    if (
      esconderMenuAcoesDispositivosBloqueio === true &&
      manejador == 'dspDispositivos'
    ) {
      let objData = await Promise.all(
        currentMainAcoes
          .filter(
            (menu) =>
              (menu.cd_pav_acao_superior !== null &&
                desabilitarAcoes &&
                menu.cd_pav_acao == 6) ||
              (!desabilitarAcoes && menu.cd_pav_acao == 6)
          )
          .map(async (menu, i) => {
            const listKey = 'menu-' + menu.cd_pav_acao

            if (menu.ds_rota_permissao) {
              if (
                await validadorPermissaoElemento(
                  permissaoElemento,
                  menu.ds_rota_permissao
                )
              ) {
                if (menu.fl_filho == false) {
                  return (
                    // nível 1
                    <li key={listKey}>
                      <div
                        className="drop-acoes-menu item-drop-acoes-hover"
                        onClick={() => {
                          handleDespacho(menu.ds_acao_redux, menu)
                        }}
                      >
                        <span className="drop-acoes-menu-label fonte-cor-1">
                          {menu.ds_acao}
                        </span>
                      </div>
                      {currentMainAcoes[i + 1] != undefined && (
                        <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                      )}
                    </li>
                  )
                } else {
                  return (
                    // nível 2 (sub-item)
                    <li key={listKey}>
                      <div
                        className="drop-acoes-menu item-drop-acoes-hover"
                        onClick={(e) =>
                          dropAcoes(
                            e,
                            listKey,
                            'imagem-menu-' + menu.cd_pav_acao
                          )
                        }
                      >
                        <span className="drop-acoes-menu-label fonte-cor-1">
                          {menu.ds_acao}
                        </span>
                        <img
                          id={'imagem-menu-' + menu.cd_pav_acao}
                          className="drop-acoes-menu-icone-desativado nao-selecionavel"
                          src={setaDropdown()}
                          alt="drop"
                        />
                      </div>
                      {currentMainAcoes[i + 1] != undefined && (
                        <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                      )}
                      <ul
                        id={listKey}
                        className="drop-acoes-lista-submenu dropdown-desativado"
                      >
                        {await renderSubAcoes(menu.cd_pav_acao)}
                      </ul>
                    </li>
                  )
                }
              }
            } else {
              if (menu.fl_filho == false) {
                return (
                  <li key={listKey}>
                    <div
                      className="drop-acoes-menu item-drop-acoes-hover"
                      onClick={() => {
                        handleDespacho(menu.ds_acao_redux, menu)
                      }}
                    >
                      <span className="drop-acoes-menu-label fonte-cor-1">
                        {menu.ds_acao}
                      </span>
                    </div>
                    {currentMainAcoes[i + 1] != undefined && (
                      <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                    )}
                  </li>
                )
              } else {
                return (
                  <li key={listKey}>
                    <div
                      className="drop-acoes-menu item-drop-acoes-hover"
                      onClick={(e) =>
                        dropAcoes(e, listKey, 'imagem-menu-' + menu.cd_pav_acao)
                      }
                    >
                      <span className="drop-acoes-menu-label fonte-cor-1">
                        {menu.ds_acao}
                      </span>
                      <img
                        id={'imagem-menu-' + menu.cd_pav_acao}
                        className="drop-acoes-menu-icone-desativado nao-selecionavel"
                        src={setaDropdown()}
                        alt="drop"
                      />
                    </div>
                    {currentMainAcoes[i + 1] != undefined && (
                      <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                    )}
                    <ul
                      id={listKey}
                      className="drop-acoes-lista-submenu dropdown-desativado"
                    >
                      {await renderSubAcoes(menu.cd_pav_acao)}
                    </ul>
                  </li>
                )
              }
            }
          })
      )
      if (isMountedRef.current) setAcoes(objData)
    } else {
      if (!currentMainAcoes) {
        return
      }

      const acoesFiltradas = currentMainAcoes.filter(
        (menu) =>
          menu.cd_pav_acao_superior !== null &&
          (!desabilitarAcoes ||
            menu.fl_selecionado == 1 ||
            reduxModoSelecaoSimcard)
      )

      let objData = await Promise.all(
        acoesFiltradas.map(async (menu, i) => {
          const listKey = 'menu-' + (menu.cd_pav_acao || 'index' + i)

          if (menu.ds_rota_permissao) {
            if (
              await validadorPermissaoElemento(
                permissaoElemento,
                menu.ds_rota_permissao
              )
            ) {
              if (menu.fl_filho == false) {
                return (
                  <li key={listKey}>
                    <div
                      className="drop-acoes-menu item-drop-acoes-hover"
                      onClick={() => {
                        handleDespacho(menu.ds_acao_redux, menu)
                      }}
                    >
                      <span className="drop-acoes-menu-label fonte-cor-1">
                        {menu.ds_acao}
                      </span>
                    </div>
                    {currentMainAcoes[i + 1] != undefined && (
                      <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                    )}
                  </li>
                )
              } else {
                return (
                  <li key={listKey}>
                    <div
                      className="drop-acoes-menu item-drop-acoes-hover"
                      onClick={(e) =>
                        dropAcoes(e, listKey, 'imagem-menu-' + menu.cd_pav_acao)
                      }
                    >
                      <span className="drop-acoes-menu-label fonte-cor-1">
                        {menu.ds_acao}
                      </span>
                      <img
                        id={'imagem-menu-' + menu.cd_pav_acao}
                        className="drop-acoes-menu-icone-desativado nao-selecionavel"
                        src={setaDropdown()}
                        alt="drop"
                      />
                    </div>
                    {currentMainAcoes[i + 1] != undefined && (
                      <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                    )}
                    <ul
                      id={listKey}
                      className="drop-acoes-lista-submenu dropdown-desativado"
                    >
                      {await renderSubAcoes(menu.cd_pav_acao)}
                    </ul>
                  </li>
                )
              }
            }
          } else {
            if (menu.fl_filho == false) {
              const acaoImportarClientesUsuarios = menu.cd_pav_acao === 269
              // gambiarra porque fizeram 1 tela poder se comportar como 2
              if (
                acaoImportarClientesUsuarios &&
                retirarAcaoDaTela('/veye/cadastro/cliente')
              ) {
                return null
              }

              return (
                <li key={listKey}>
                  <div
                    className="drop-acoes-menu item-drop-acoes-hover"
                    onClick={() => {
                      handleDespacho(menu.ds_acao_redux, menu)
                    }}
                  >
                    <span className="drop-acoes-menu-label fonte-cor-1">
                      {menu.ds_acao}
                    </span>
                  </div>
                  {currentMainAcoes[i + 1] != undefined && (
                    <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                  )}
                </li>
              )
            } else {
              return (
                <li key={listKey}>
                  <div
                    className="drop-acoes-menu item-drop-acoes-hover"
                    onClick={(e) =>
                      dropAcoes(e, listKey, 'imagem-menu-' + menu.cd_pav_acao)
                    }
                  >
                    <span className="drop-acoes-menu-label fonte-cor-1">
                      {menu.ds_acao}
                    </span>
                    <img
                      id={'imagem-menu-' + menu.cd_pav_acao}
                      className="drop-acoes-menu-icone-desativado nao-selecionavel"
                      src={setaDropdown()}
                      alt="drop"
                    />
                  </div>
                  <div className="drop-acoes-divisora campo-select-divisor-cor-1" />
                  <ul
                    id={listKey}
                    className="drop-acoes-lista-submenu dropdown-desativado"
                  >
                    {await renderSubAcoes(menu.cd_pav_acao)}
                  </ul>
                </li>
              )
            }
          }
        })
      )
      if (isMountedRef.current) setAcoes(objData)
    }
  }

  function retirarAcaoDaTela(telaRetirarAcao) {
    const path = window.location.pathname

    if (path === telaRetirarAcao) {
      return true
    }
  }

  //ESTE É O COMPONENTE QUE RENDERIZA O DROPDOWN DE AÇÕES
  async function handleDespacho(acaoRedux, acaoObj = null) {
    const isDSP = manejador === 'dspDispositivos'

    // Busca ação caso não tenha vindo por parâmetro
    const getAcao = () => {
      if (acaoObj) return acaoObj
      return (
        currentMainAcoes.find((a) => a.ds_acao_redux === acaoRedux) ||
        currentSubAcoes.find((a) => a.ds_acao_redux === acaoRedux)
      )
    }

    if (!isDSP) {
      executarAcao(acaoRedux)
      return
    }

    const acao = getAcao()
    const isESimAction = acao?.fl_esim == 1
    const isSelectedAction = acao?.fl_selecionado != 1

    if (!isESimAction) {
      executarAcao(acaoRedux)
      return
    }

    // Habilitar/Desabilitar Siga é permitido para eSIMs
    const isAcaoSiga =
      acaoRedux === 'revelarHabilitarSiga' ||
      acaoRedux === 'revelarDesabilitarSiga'

    if (isAcaoSiga) {
      executarAcao(acaoRedux)
      return
    }

    try {
      if (linhasSelecionadas?.length > 0 && isSelectedAction) {
        if (isMountedRef.current) {
          setConfirmacaoAcao({
            open: true,
            acaoRedux,
            acao,
            callback: () => executarAcao(acaoRedux)
          })
        }
        return
      }

      if (selecionarParqueInteiro && isSelectedAction) {
        const response = await getHasESimOnDevices()
        const hasESimInDevices = response?.devices?.length > 0

        if (hasESimInDevices && isMountedRef.current) {
          setConfirmacaoAcao({
            open: true,
            acaoRedux,
            acao,
            parquetodo: true,
            callback: () => executarAcao(acaoRedux)
          })
          return
        }
      }
      executarAcao(acaoRedux)
    } catch (error) {
      console.error('Erro ao validar ação:', error)

      if (isMountedRef.current) {
        setMostrarNotificacao({
          show: true,
          autoHide: 6000,
          type: 'error',
          title: 'Falha ao executar a ação',
          message:
            'Algo deu errado durante o processamento. Por favor, tente novamente.'
        })
      }
    } finally {
      if (isMountedRef.current) props.toggleRevelarDropAcoes(false)
    }
  }

  async function executarAcao(acaoRedux) {
    //  #region  acoes REDUX
    if (acaoRedux === 'revelarAtribuirLinhas') {
      despacho(revelarAtribuirLinhas(true))
      props.toggleRevelarDropAcoes(false)
    }

    if (acaoRedux === 'revelarDesatribuirLinhas') {
      despacho(revelarDesatribuirLinhas(true))
      props.toggleRevelarDropAcoes(false)
    }

    if (acaoRedux === 'revelarAdicionarPacoteExtra') {
      ColetaClickstream(210) // 'dropAcoesRevelarAdicionarPacoteExtra'
      despacho(revelarAdicionarPacoteExtra(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */

    if (acaoRedux === 'revelarResetFaturas') {
      despacho(revelarResetFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAlterarICCIDFaturas') {
      despacho(revelarAlterarICCIDFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAlterarcontaFaturas') {
      despacho(revelarAlterarcontaFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAlterarciclodevidaFaturas') {
      despacho(revelarAlterarciclodevidaFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAlterarplanoFaturas') {
      despacho(revelarAlterarplanoFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarLiberarSMSFaturas') {
      despacho(revelarLiberarSMSFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDesativarSMSFaturas') {
      despacho(revelarDesativarSMSFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAlteracaoprazodepermanenciaFaturas') {
      despacho(revelarAlteracaoprazodepermanenciaFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }

    if (acaoRedux === 'revelarReset') {
      ColetaClickstream(211) // 'dropAcoesRevelarReset'
      despacho(revelarReset(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarTesteConexao') {
      ColetaClickstream(1485) // 'dropAcoesRevelarTesteConexao'
      despacho(revelarTesteConexao(true))
      props.toggleRevelarDropAcoes(false)
    }

    if (acaoRedux === 'revelarFalhaNaOperadora') {
      ColetaClickstream(212) // 'dropAcoesRevelarFalhaNaOperadora'
      despacho(revelarFalhaNaOperadora(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarSuporteTecnico') {
      ColetaClickstream(213) // 'dropAcoesRevelarSuporteTecnico'
      despacho(revelarSuporteTecnico(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarRealocacao') {
      ColetaClickstream(214) // 'dropAcoesRevelarRealocacao'
      despacho(revelarRealocacao(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCancelamento') {
      ColetaClickstream(215) // 'dropAcoesRevelarCancelamento'
      despacho(revelarCancelamento(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCancelamentoReposicao') {
      ColetaClickstream(216) // 'dropAcoesRevelarCancelamentoReposicao'
      despacho(revelarCancelamentoReposicao(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarAtivarLinha') {
      ColetaClickstream(217) // 'dropAcoesRevelarAtivarLinha'
      despacho(revelarAtivarLinha(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarLinhasCsvOperadora') {
      ColetaClickstream(236) // 'dropAcoesExportarLinhasCsv'
      despacho(exportarLinhasOperadora('CSV'))
      despacho(exportarOperadora(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarLinhasXlsOperadora') {
      ColetaClickstream(236) // 'dropAcoesExportarLinhasXLS'
      despacho(exportarLinhasOperadora('XLS'))
      despacho(exportarOperadora(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarLinhasXlsxOperadora') {
      ColetaClickstream(236) // 'dropAcoesExportarLinhasXLSX'
      despacho(exportarLinhasOperadora('XLSX'))
      despacho(exportarOperadora(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarReativarLinha') {
      ColetaClickstream(218) // 'dropAcoesRevelarReativarLinha'
      despacho(revelarReativarLinha(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDesbloquearUso') {
      ColetaClickstream(219) // 'dropAcoesRevelarDesbloquearUso'
      despacho(revelarDesbloquearUso(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDesbloqueioCiclo') {
      despacho(revelarDesbloqueioCiclo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDesbloqueioPermanente') {
      despacho(revelarDesbloqueioPermanente(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRemoverBloqueioTemporario') {
      ColetaClickstream(220) // 'dropAcoesRevelarBloqueioTemporario'
      despacho(revelarRemoverBloqueioTemporario(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarSuspenderLinha') {
      ColetaClickstream(221) // 'dropAcoesRevelarSuspenderLinha'
      despacho(revelarSuspenderLinha(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarBloquearUso') {
      ColetaClickstream(222) // 'dropAcoesRevelarBloquearUso'
      despacho(revelarBloquearUso(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarBloquearTemporariamento') {
      ColetaClickstream(223) // 'dropAcoesRevelarBloquearTemporariamento'
      despacho(revelarBloquearTemporariamento(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarAlterarPlanoValor') {
      ColetaClickstream(224) // 'dropAcoesRevelarAlterarPlanoValor'
      despacho(revelarAlterarPlanoValor(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRenegociarContrato') {
      despacho(revelarRenegociarContrato(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarTrocaDeTitularidade') {
      ColetaClickstream(225) // 'dropAcoesRevelarTrocaDeTitularidade'
      despacho(revelarTrocaDeTitularidade(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarAtivarDemonstracao') {
      ColetaClickstream(226) // 'dropAcoesRevelarAtivarDemonstracao'
      despacho(revelarAtivarDemonstracao(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDesativarDemonstracao') {
      ColetaClickstream(227) // 'dropAcoesRevelarDesativarDemonstracao'
      despacho(revelarDesativarDemonstracao(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarCancelamentoDeConta') {
      ColetaClickstream(228) // 'dropAcoesRevelarCancelamentoDeConta'
      despacho(revelarCancelamentoDeConta(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarTransferirLinhaClienteFinal') {
      despacho(revelarTransferirLinhaClienteFinal(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarLiberarSms') {
      ColetaClickstream(229) // 'dropAcoesRevelarLiberarSms'
      despacho(revelarLiberarSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarBloquearSms') {
      ColetaClickstream(230) // 'dropAcoesRevelarBloquearSms'
      despacho(revelarBloquearSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEnviarSms') {
      ColetaClickstream(231) // 'dropAcoesRevelarEnviarSms'
      despacho(revelarEnviarSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarMapa') {
      ColetaClickstream(232) // 'dropAcoesRevelarMapa'
      despacho(revelarMapa(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAlterarGrupo') {
      ColetaClickstream(233) // 'dropAcoesAlterarGrupo'
      despacho(revelarAlterarGrupo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarConfigurarGrupo') {
      despacho(revelarConfigurarGrupo(true))
    }
    if (acaoRedux === 'revelarImportarDescricao') {
      ColetaClickstream(235) // 'dropAcoesImportarDescricao'
      despacho(revelarImportarDescricao(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioConsumo') {
      ColetaClickstream(1484) // 'dropAcoesRelatorioConsumo'
      despacho(revelarRelatorioConsumo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioDisponibilidade') {
      despacho(revelarRelatorioDisponibilidade(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarLinhasCsv') {
      ColetaClickstream(236) // 'dropAcoesExportarLinhasCsv'
      despacho(exportarLinhas('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarLinhasXls') {
      ColetaClickstream(237) // 'dropAcoesExportarLinhasXls'
      despacho(exportarLinhas('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarLinhasXlsx') {
      ColetaClickstream(238) // 'dropAcoesExportarLinhasXlsx'
      despacho(exportarLinhas('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }

    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarConsultarSimcard') {
      ColetaClickstream(239) // 'dropAcoesRevelarConsultarSimcard'
      despacho(revelarConsultarSimcard(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarHistoricoAcessos') {
      ColetaClickstream(240) // 'dropAcoesRevelarHistoricoAcessos'
      despacho(revelarHistoricoAcessos(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCadastrarUsuario') {
      ColetaClickstream(241) // 'dropAcoesRevelarCadastrarUsuario'
      despacho(revelarCadastrarUsuario(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAdicionarLogin') {
      ColetaClickstream(242) // 'dropAcoesRevelarAdicionarLogin'
      despacho(revelarAdicionarLogin(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDoppelgangerCliente') {
      ColetaClickstream(243) // 'dropAcoesRevelarDoppelgangerCliente'
      despacho(revelarDoppelgangerCliente(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarEnviarSmsModulo') {
      ColetaClickstream(244) // 'dropAcoesRevelarEnviarSmsModulo'
      despacho(revelarEnviarSmsModulo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarVerConversasSms') {
      ColetaClickstream(245) // 'dropAcoesRevelarVerConversasSms'
      despacho(revelarVerConversasSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAtualizarSms') {
      ColetaClickstream(246) // 'dropAcoesRevelarAtualizarSms'
      despacho(revelarAtualizarSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioEnvioSms') {
      //          ColetaClickstream() // 'dropAcoesRevelarRelatorioEnvioSms'
      despacho(revelarRelatorioEnvioSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarProcessarPedido') {
      ColetaClickstream(247) // 'dropAcoesRevelarProcessarPedido'
      despacho(revelarProcessarPedido(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarConcluirPedido') {
      ColetaClickstream(248) // 'dropAcoesRevelarConcluirPedido'
      despacho(revelarConcluirPedido(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCancelarPedido') {
      ColetaClickstream(249) // 'dropAcoesRevelarCancelarPedido'
      despacho(revelarCancelarPedido(true))
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'solicitacaConcluirVirtueyes') {
      ColetaClickstream(250) // 'dropAcoesSolicitacaConcluirVirtueyes'
      despacho(solicitacaConcluirVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'solicitacaCancelarVirtueyes') {
      ColetaClickstream(251) // 'dropAcoesSolicitacaCancelarVirtueyes'
      despacho(solicitacaCancelarVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'solicitacaReenviarProtocoloVirtueyes') {
      ColetaClickstream(252) // 'dropAcoesSolicitacaReenviarProtocoloVirtueyes'
      despacho(solicitacaReenviarProtocoloVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'solicitacaReenviarTrocaOcorrenciaVirtueyes') {
      ColetaClickstream(253) // 'dropAcoesSolicitacaReenviarTrocaOcorrenciaVirtueyes'
      despacho(solicitacaReenviarTrocaOcorrenciaVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarLogReset') {
      ColetaClickstream(254) // 'dropAcoesRevelarLogReset'
      despacho(revelarLogReset(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'confimarRecebimentoVirtueyes') {
      ColetaClickstream(255) // 'dropAcoesConfimarRecebimentoVirtueyes'
      despacho(confimarRecebimentoVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'reenviarEmailVirtueyes') {
      ColetaClickstream(256) // 'dropAcoesReenviarEmailVirtueyes'
      despacho(reenviarEmailVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'novaSolicitacaoVirtueyes') {
      ColetaClickstream(257) // 'dropAcoesNovaSolicitacaoVirtueyes'
      despacho(novaSolicitacaoVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarNovoTemplateSms') {
      despacho(revelarNovoTemplateSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarTemplateSms') {
      despacho(revelarEditarTemplateSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirTemplateSms') {
      despacho(revelarExcluirTemplateSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoPedidoSMS') {
      ColetaClickstream(261) // 'dropAcoesRevelarNovoPedidoSMS'
      despacho(revelarNovoPedidoSMS(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarNovoPedidoSimcard') {
      despacho(revelarNovoPedidoSimcard(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarMostrarEmDispositivos') {
      ColetaClickstream(263) // 'dropAcoesRevelarMostrarEmDispositivos'
      despacho(revelarMostrarEmDispositivos(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExportarDetalhamento') {
      ColetaClickstream(264) // 'dropAcoesRevelarExportarDetalhamento'
      despacho(revelarExportarDetalhamento(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDownloadBoleto') {
      ColetaClickstream(265) // 'dropAcoesRevelarDownloadBoleto'
      despacho(revelarDownloadBoleto(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExportarDetalhamentoFinanceiro') {
      ColetaClickstream(266) // 'dropAcoesRevelarExportarDetalhamentoFinanceiro'
      despacho(revelarExportarDetalhamentoFinanceiro(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'revelarNovaRegra') {
      ColetaClickstream(267) // 'dropAcoesRevelarNovaRegra'
      despacho(revelarNovaRegra(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarRegra') {
      ColetaClickstream(268) // 'dropAcoesRevelarEditarRegra'
      despacho(revelarEditarRegra(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirRegra') {
      ColetaClickstream(269) // 'dropAcoesRevelarExcluirRegra'
      despacho(revelarExcluirRegra(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarHabilitarRegra') {
      ColetaClickstream(270) // 'dropAcoesRevelarHabilitarRegra'
      despacho(revelarHabilitarRegra(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDesabilitarRegra') {
      ColetaClickstream(271) // 'dropAcoesRevelarDesabilitarRegra'
      despacho(revelarDesabilitarRegra(true))
      props.toggleRevelarDropAcoes(false)
    }
    /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */ /*  */
    if (acaoRedux === 'solicitacaBloquearVirtueyes') {
      ColetaClickstream(272) // 'dropAcoesSolicitacaBloquearVirtueyes'
      despacho(revelarSolicitacaBloquearVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'solicitacaRemoverBloqueioVirtueyes') {
      ColetaClickstream(273) // 'dropAcoesSolicitacaRemoverBloqueioVirtueyes'
      despacho(revelarSolicitacaRemoverBloqueioVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'solicitacaEnviarAvisoVirtueyes') {
      ColetaClickstream(274) // 'dropAcoesSolicitacaEnviarAvisoVirtueyes'
      despacho(revelarSolicitacaEnviarAvisoVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovaMensagem') {
      ColetaClickstream(275) // 'dropAcoesRevelarNovaMensagem'
      despacho(revelarNovaMensagem(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'solicitacaExportarVirtueyes') {
      ColetaClickstream(276) // 'dropAcoesSolicitacaExportarVirtueyes'
      despacho(revelarSolicitacaExportarVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */
    if (acaoRedux === 'revelarNovoUsuarioCliente') {
      despacho(revelarNovoUsuarioCliente(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEdicaoUsuario') {
      ColetaClickstream(278) // 'dropAcoesRevelarEdicaoUsuario'
      despacho(revelarEdicaoUsuario(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirUsuarioCliente') {
      ColetaClickstream(279) // 'dropAcoesRevelarExcluirUsuarioCliente'
      despacho(revelarExcluirUsuarioCliente(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarReenviarLinkPrimeiroAcessoUsuarioCliente') {
      ColetaClickstream(1486) // 'dropAcoesRevelarReenviarLinkPrimeiroAcessoUsuarioCliente'
      despacho(revelarReenviarLinkPrimeiroAcessoUsuarioCliente(true))
      props.toggleRevelarDropAcoes(false)
    }

    /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */ /* */
    if (acaoRedux === 'revelarNovoUsuario') {
      ColetaClickstream(280) // 'dropAcoesRevelarNovoUsuario'
      despacho(revelarNovoUsuario(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarUsuario') {
      ColetaClickstream(281) // 'dropAcoesRevelarEditarUsuario'
      despacho(revelarEditarUsuario(true))
      props.toggleRevelarDropAcoes(false)
    }
    // if (acaoRedux === "revelarClonarUsuario") {
    //   ColetaClickstream(281); // 'dropAcoesRevelarEditarUsuario'
    //   despacho(revelarClonarUsuario(true));
    //   props.toggleRevelarDropAcoes(false);
    // }
    if (acaoRedux === 'revelarExcluirUsuario') {
      ColetaClickstream(282) // 'dropAcoesRevelarExcluirUsuario'
      despacho(revelarExcluirUsuario(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoCliente') {
      ColetaClickstream(283) // 'dropAcoesRevelarNovoCliente'
      despacho(revelarNovoCliente(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarCliente') {
      ColetaClickstream(284) // 'dropAcoesRevelarEditarCliente'
      despacho(revelarEditarCliente(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirCliente') {
      ColetaClickstream(285) // 'dropAcoesRevelarExcluirCliente'
      despacho(revelarExcluirCliente(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoElemento') {
      ColetaClickstream(286) // 'dropAcoesRevelarNovoElemento'
      despacho(revelarNovoElemento(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarElemento') {
      ColetaClickstream(287) // 'dropAcoesRevelarEditarElemento'
      despacho(revelarEditarElemento(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirElemento') {
      despacho(revelarExcluirElemento(true))
      props.toggleRevelarDropAcoes(false)
    }

    if (acaoRedux === 'revelarNovoModulo') {
      ColetaClickstream(289) // 'dropAcoesRevelarNovoModulo'
      despacho(revelarNovoModulo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarModulo') {
      ColetaClickstream(290) // 'dropAcoesRevelarEditarModulo'
      despacho(revelarEditarModulo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirModulo') {
      despacho(revelarExcluirModulo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoPerfil') {
      ColetaClickstream(292) // 'dropAcoesRevelarNovoPerfil'
      despacho(revelarNovoPerfil(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarPerfil') {
      ColetaClickstream(293) // 'dropAcoesRevelarEditarPerfil'
      despacho(revelarEditarPerfil(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirPerfil') {
      despacho(revelarExcluirPerfil(true))
      props.toggleRevelarDropAcoes(false)
    }

    if (acaoRedux === 'revelarNovoSistema') {
      ColetaClickstream(295) // 'dropAcoesRevelarNovoSistema'
      despacho(revelarNovoSistema(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarSistema') {
      ColetaClickstream(296) // 'dropAcoesRevelarEditarSistema'
      despacho(revelarEditarSistema(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirSistema') {
      despacho(revelarExcluirSistema(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoTela') {
      ColetaClickstream(298) // 'dropAcoesRevelarNovoTela'
      despacho(revelarNovoTela(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarTela') {
      ColetaClickstream(299) // 'dropAcoesRevelarEditarTela'
      despacho(revelarEditarTela(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirTela') {
      despacho(revelarExcluirTela(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirFatPedidos') {
      despacho(revelarExcluirFatPedidos(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoFatPedidos') {
      ColetaClickstream(302) // 'dropAcoesRevelarNovoFatPedidos'
      despacho(revelarNovoFatPedidos(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarFatPedidos') {
      despacho(revelarEditarFatPedidos(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAssociarFatura') {
      ColetaClickstream(304) // 'dropAcoesRevelarAssociarFatura'
      despacho(revelarAssociarFatura(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAlterarPrazoPermanencia') {
      ColetaClickstream(305) // 'dropAcoesRevelarAlterarPrazoPermanencia'
      despacho(revelarAlterarPrazoPermanencia(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarImportarFebrabans') {
      ColetaClickstream(306) // 'dropAcoesRevelarImportarFebrabans'
      despacho(revelarImportarFebrabans(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoPedidoImportado') {
      despacho(revelarNovoPedidoImportado(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirFebraban') {
      ColetaClickstream(307) // 'dropAcoesRevelarExcluirFebraban'
      despacho(revelarExcluirFebraban(true))
    }
    if (acaoRedux === 'revelarNovaConta') {
      ColetaClickstream(308) // 'dropAcoesRevelarNovaConta'
      despacho(revelarNovaConta(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarConta') {
      ColetaClickstream(309) // 'dropAcoesRevelarEditarConta'
      despacho(revelarEditarConta(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirConta') {
      ColetaClickstream(310) // 'dropAcoesRevelarExcluirConta'
      despacho(revelarExcluirConta(true))
    }
    if (acaoRedux === 'revelarNovaEmpresa') {
      ColetaClickstream(311) // 'dropAcoesRevelarNovaEmpresa'
      despacho(revelarNovaEmpresa(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarEmpresa') {
      ColetaClickstream(312) // 'dropAcoesRevelarEditarEmpresa'
      despacho(revelarEditarEmpresa(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirEmpresa') {
      despacho(revelarExcluirEmpresa(true))
    }
    if (acaoRedux === 'revelarNovoPlano') {
      ColetaClickstream(314) // 'dropAcoesRevelarNovoPlano'
      despacho(revelarNovoPlano(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarPlano') {
      ColetaClickstream(315) // 'dropAcoesRevelarEditarPlano'
      despacho(revelarEditarPlano(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirPlano') {
      ColetaClickstream(316) // 'dropAcoesRevelarExcluirPlano'
      despacho(revelarExcluirPlano(true))
      props.toggleRevelarDropAcoes(false)
    }

    if (acaoRedux === 'revelarNovoCicloVida') {
      ColetaClickstream(317) // 'dropAcoesRevelarNovoCicloVida'
      despacho(revelarNovoCicloVida(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarCicloVida') {
      ColetaClickstream(318) // 'dropAcoesRevelarEditarCicloVida'
      despacho(revelarEditarCicloVida(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirCicloVida') {
      ColetaClickstream(1408) // 'dropAcoesRevelarExcluirCicloVida'
      despacho(revelarExcluirCicloVida(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarLinhasDesbloqueioCicloXLSX') {
      despacho(exportarLinhasDesbloqueioCiclo('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarLinhasDesbloqueioCicloCSV') {
      despacho(exportarLinhasDesbloqueioCiclo('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarRelatorioSigaXLSX') {
      despacho(exportarRelatorioSiga('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'exportarRelatorioSigaCSV') {
      despacho(exportarRelatorioSiga('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoFornecedor') {
      ColetaClickstream(320) // 'dropAcoesRevelarNovoFornecedor'
      despacho(revelarNovoFornecedor(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarFornecedor') {
      ColetaClickstream(321) // 'dropAcoesRevelarEditarFornecedor'
      despacho(revelarEditarFornecedor(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirFornecedor') {
      ColetaClickstream(322) // 'dropAcoesRevelarExcluirFornecedor'
      despacho(revelarExcluirFornecedor(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoServico') {
      ColetaClickstream(323) // 'dropAcoesRevelarNovoServico'
      despacho(revelarNovoServico(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirEmpresa') {
      despacho(revelarExcluirEmpresa(true))
    }
    if (acaoRedux === 'revelarEditarServico') {
      ColetaClickstream(325) // 'dropAcoesRevelarEditarServico'
      despacho(revelarEditarServico(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirServico') {
      ColetaClickstream(326) // 'dropAcoesRevelarExcluirServico'
      despacho(revelarExcluirServico(true))
    }
    if (acaoRedux === 'revelarNovaOperadora') {
      ColetaClickstream(327) // 'dropAcoesRevelarNovaOperadora'
      despacho(revelarNovaOperadora(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarOperadora') {
      ColetaClickstream(328) // 'dropAcoesRevelarEditarOperadora'
      despacho(revelarEditarOperadora(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirOperadora') {
      ColetaClickstream(329) // 'dropAcoesRevelarExcluirOperadora'
      despacho(revelarExcluirOperadora(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDispositivosAlterarServicos') {
      ColetaClickstream(330) // 'dropAcoesRevelarDispositivosAlterarServicos'
      despacho(revelarDispositivosAlterarServicos(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDispositivosAlterarPlano') {
      ColetaClickstream(331) // 'dropAcoesRevelarDispositivosAlterarPlano'
      despacho(revelarDispositivosAlterarPlano(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDispositivosAlterarCicloDeVida') {
      ColetaClickstream(332) // 'dropAcoesRevelarDispositivosAlterarCicloDeVida'
      despacho(revelarDispositivosAlterarCicloDeVida(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDispositivosAlterarIccid') {
      despacho(revelarDispositivosAlterarIccid(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDispositivosAlterarConta') {
      ColetaClickstream(334) // 'dropAcoesRevelarDispositivosAlterarConta'
      despacho(revelarDispositivosAlterarConta(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarSolicitacao') {
      ColetaClickstream(335) // 'dropAcoesRevelarEditarSolicitacao'
      despacho(revelarEditarSolicitacao(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioLinhasAfetadasCsv') {
      despacho(revelarRelatorioLinhasAfetadas('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioLinhasAfetadasXls') {
      despacho(revelarRelatorioLinhasAfetadas('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioLinhasAfetadasXlsx') {
      despacho(revelarRelatorioLinhasAfetadas('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioLinhasIgnoradasCsv') {
      despacho(revelarRelatorioFatura('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioLinhasIgnoradasXls') {
      despacho(revelarRelatorioFatura('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioLinhasIgnoradasXlsx') {
      despacho(revelarRelatorioFatura('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirSolicitacao') {
      despacho(revelarExcluirSolicitacao(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarFiltrarSolicitacaoPorArquivo') {
      despacho(revelarFiltrarSolicitacaoPorArquivo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'limparFiltroPorArquivoFatSolicitacao') {
      despacho(limparFiltroPorArquivoFatSolicitacao(!limparFiltroPorArquivo))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarMostrarEmDispositivosSolicitacao') {
      despacho(revelarMostrarEmDispositivosSolicitacao(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarReenviarSolicitacaoFaturas') {
      ColetaClickstream(1487) // 'dropAcoesRevelar...'
      despacho(revelarReenviarSolicitacaoFaturas(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAbrirTelaConciliacao') {
      despacho(revelarAbrirTelaConciliacao(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarFatura') {
      despacho(revelarEditarFatura(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCadastrarFatura') {
      ColetaClickstream(342) // 'dropAcoesRevelarCadastrarFatura'
      despacho(revelarCadastrarFatura(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDeletarFatura') {
      despacho(revelarDeletarFatura(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirFatura') {
      despacho(revelarExcluirFatura(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarContestarFatura') {
      despacho(revelarContestarFatura(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRecalcularFatura') {
      despacho(revelarRecalcularFatura(true))
      props.toggleRevelarDropAcoes(false)
    }
    // RELATORIOS PREVIEW//
    if (acaoRedux === 'revelarRelatorioPreviewFaturaCsv') {
      ColetaClickstream(1446) // FaturasFaturasDropAcoesRelatorioPreviewCSV
      despacho(revelarRelatorioPreviewFatura('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioPreviewFaturaXls') {
      ColetaClickstream(1447) // FaturasFaturasDropAcoesRelatorioPreviewXLS
      despacho(revelarRelatorioPreviewFatura('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioPreviewFaturaXlsx') {
      ColetaClickstream(1448) // FaturasFaturasDropAcoesRelatorioPreviewXLSX
      despacho(revelarRelatorioPreviewFatura('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioResumoFebrabanCsv') {
      ColetaClickstream(1446) // FaturasFaturasDropAcoesRelatorioPreviewCSV
      despacho(revelarRelatorioResumoFebraban('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioResumoFebrabanXls') {
      ColetaClickstream(1447) // FaturasFaturasDropAcoesRelatorioPreviewXLS
      despacho(revelarRelatorioResumoFebraban('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioResumoFebrabanXlsx') {
      ColetaClickstream(1448) // FaturasFaturasDropAcoesRelatorioPreviewXLSX
      despacho(revelarRelatorioResumoFebraban('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    // RELATORIOS FATURAS //
    if (acaoRedux === 'revelarRelatorioFaturaCsv') {
      ColetaClickstream(350) // 'dropAcoesRevelarRelatorioFaturaCsv'
      despacho(revelarRelatorioFatura('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioFaturaXls') {
      ColetaClickstream(351) // 'dropAcoesRevelarRelatorioFaturaXls'
      despacho(revelarRelatorioFatura('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioFaturaXlsx') {
      ColetaClickstream(352) // 'dropAcoesRevelarRelatorioFaturaXlsx'
      despacho(revelarRelatorioFatura('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    // RELATORIOS NOTA FISCAL //
    if (acaoRedux === 'revelarRelatorioNotaFiscalGeralCsv') {
      ColetaClickstream(353) // 'dropAcoesRevelarRelatorioNotaFiscalGeralCsv'
      despacho(revelarRelatorioNotaFiscalGeral('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioNotaFiscalGeralXls') {
      ColetaClickstream(354) // 'dropAcoesRevelarRelatorioNotaFiscalGeralXls'
      despacho(revelarRelatorioNotaFiscalGeral('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioNotaFiscalGeralXlsx') {
      ColetaClickstream(355) // 'dropAcoesRevelarRelatorioNotaFiscalGeralXlsx'
      despacho(revelarRelatorioNotaFiscalGeral('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioFebrabanCsv') {
      ColetaClickstream(356) // 'dropAcoesRevelarRelatorioFebrabanCsv'
      despacho(revelarRelatorioFebraban('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioFebrabanXls') {
      ColetaClickstream(357) // 'dropAcoesRevelarRelatorioFebrabanXls'
      despacho(revelarRelatorioFebraban('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioFebrabanXlsx') {
      ColetaClickstream(358) // 'dropAcoesRevelarRelatorioFebrabanXlsx'
      despacho(revelarRelatorioFebraban('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioFaturaDispositivosCsv') {
      ColetaClickstream(359) // 'dropAcoesRevelarRelatorioFaturaDispositivosCsv'
      despacho(revelarRelatorioFaturaDispositivos('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioFaturaDispositivosXls') {
      ColetaClickstream(360) // 'dropAcoesRevelarRelatorioFaturaDispositivosXls'
      despacho(revelarRelatorioFaturaDispositivos('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioFaturaDispositivosXlsx') {
      ColetaClickstream(361) // 'dropAcoesRevelarRelatorioFaturaDispositivosXlsx'
      despacho(revelarRelatorioFaturaDispositivos('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioConciliacaoCsv') {
      despacho(revelarRelatorioConciliacao('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioConciliacaoXls') {
      despacho(revelarRelatorioConciliacao('XLS'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRelatorioConciliacaoXlsx') {
      despacho(revelarRelatorioConciliacao('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAtualizarConciliacao') {
      despacho(revelarAtualizarConciliacao(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoPedidoSmsVirtueyes') {
      ColetaClickstream(366) // 'dropAcoesRevelarNovoPedidoSmsVirtueyes'
      despacho(revelarNovoPedidoSmsVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarGerarRelatorios') {
      despacho(revelarGerarRelatorios(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCadastroCliente') {
      despacho(revelarCadastroCliente(true))
    }
    if (acaoRedux === 'revelarCadastroClienteVirtueyes') {
      ColetaClickstream(368) // 'dropAcoesRevelarCadastroClienteVirtueyes'
      despacho(revelarCadastroClienteVirtueyes(true))
      props.toggleRevelarDropAcoes(false)
    }
    // --------------- PAINEL RELATORIOS --------------- //
    if (acaoRedux === 'revelarDownloadRelatorio') {
      ColetaClickstream(369) // 'dropAcoesRevelarDownloadRelatorio'
      despacho(revelarDownloadRelatorio(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarGerarRelatorio') {
      ColetaClickstream(370) // 'dropAcoesRevelarGerarRelatorio'
      despacho(revelarGerarRelatorio(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoRelease') {
      ColetaClickstream(371) // 'dropAcoesRevelarNovoRelease'
      despacho(revelarNovoRelease(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarNovoMenu') {
      ColetaClickstream(372) // 'dropAcoesRevelarNovoMenu'
      despacho(revelarNovoMenu(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarEditarMenu') {
      ColetaClickstream(373) // 'dropAcoesRevelarEditarMenu'
      despacho(revelarEditarMenu(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExcluirMenu') {
      despacho(revelarExcluirMenu(true))
      props.toggleRevelarDropAcoes(false)
    }
    /****************** PAINEL CADASTROS *********************/
    if (acaoRedux === 'revelarCadastroClienteExcluir') {
      ColetaClickstream(1431) // dropAcoesRevelarCadastroClienteExcluir
      despacho(revelarCadastroClienteExcluir(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCadastroClienteEditar') {
      ColetaClickstream(1430) // dropAcoesRevelarCadastroClienteEditar
      despacho(revelarCadastroClienteEditar(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCadastroClienteNovo') {
      ColetaClickstream(1429) // dropAcoesrevelarCadastroClienteNovo
      despacho(revelarCadastroClienteNovo(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCadastroClienteCarregar') {
      ColetaClickstream(1432) // dropAcoesRevelarCadastroClienteCarregar
      despacho(revelarCadastroClienteCarregar(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarDeletarPedidoImportado') {
      ColetaClickstream(1432) // revelarDeletarPedidoImportado
      despacho(revelarDeletarPedidoImportado(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRecalcularFaturaReferencia') {
      despacho(revelarRecalcularFaturaReferencia(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRecalcularFaturaConta') {
      despacho(revelarRecalcularFaturaConta(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRecalcularFaturaEmpresa') {
      despacho(revelarRecalcularFaturaEmpresa(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'conciliacaoEmLote') {
      despacho(conciliacaoEmLote(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarIotTelecom') {
      despacho(revelarIotTelecom(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarAtivarLinhasAWS') {
      despacho(revelarAtivarLinhasAWS(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarImportarClientesUsuarios') {
      ColetaClickstream(283) // 'dropAcoesRevelarNovoCliente'
      despacho(revelarImportarClientesUsuarios(true))
      props.toggleRevelarDropAcoes(false)
      // ColetaClickstream(235) // 'dropAcoesImportarDescricao'
      // despacho(revelarImportarDescricao(true))
      // props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExportarLinhasMigracaoPlanoCSV') {
      // ColetaClickstream(?) // TODO: 'dropAcoesExportarLinhasXls ?'
      despacho(exportarLinhas('CSV'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarExportarLinhasMigracaoPlanoXLSX') {
      // ColetaClickstream(?) // TODO: 'dropAcoesExportarLinhasXls ?'
      despacho(exportarLinhas('XLSX'))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarCriarContaSms') {
      ColetaClickstream(281) // 'dropAcoesRevelarEditarUsuario'
      despacho(revelarCriarContaSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    if (acaoRedux === 'revelarRemoverContaSms') {
      ColetaClickstream(281) // 'dropAcoesRevelarEditarUsuario'
      despacho(revelarRemoverContaSms(true))
      props.toggleRevelarDropAcoes(false)
    }
    //#endregion acoes REDUX
    if (relatoriosZustand.some((rel) => acaoRedux?.includes(rel))) {
      const acao =
        relatoriosZustand.find((rel) => acaoRedux.includes(rel)) || ''
      const tipo = acaoRedux.replace(acao, '')

      setExportarRelatorio({
        acao,
        tipo
      })
      props.toggleRevelarDropAcoes(false)
    }

    if (acoesZustand.some((rel) => acaoRedux?.includes(rel))) {
      setMostrarAcao(acaoRedux)
      props.toggleRevelarDropAcoes(false)
    }
  }

  function dropAcoes(event, elementoId, imagemId) {
    ColetaClickstream(1075) // 'dropAcoes'
    let elemento = document.getElementById(elementoId)
    let imagem = document.getElementById(imagemId)

    let imagemClasses = document.querySelectorAll(
      '.drop-acoes-menu-icone-ativado'
    )
    let classes = document.querySelectorAll('.dropdown-ativado')

    if (elemento.classList.contains('dropdown-desativado')) {
      if (classes.length > 0) {
        classes.forEach((item) => item.classList.remove('dropdown-desativado'))
        classes.forEach((item) => item.classList.add('dropdown-ativado'))

        imagemClasses.forEach((item) =>
          item.classList.remove('drop-acoes-menu-icone-desativado')
        )
        imagemClasses.forEach((item) =>
          item.classList.add('drop-acoes-menu-icone-ativado')
        )
      }
      elemento.classList.add('dropdown-ativado')
      elemento.classList.remove('dropdown-desativado')

      imagem.classList.add('drop-acoes-menu-icone-ativado')
      imagem.classList.remove('drop-acoes-menu-icone-desativado')
    }
    // se o filtro estiver ativado e for clicado em cima do mesmo filtro ele fecha
    else if (elemento.classList.contains('dropdown-ativado')) {
      if (classes.length > 0) {
        classes.forEach((item) => item.classList.add('dropdown-desativado'))
        classes.forEach((item) => item.classList.remove('dropdown-ativado'))

        imagemClasses.forEach((item) =>
          item.classList.add('drop-acoes-menu-icone-desativado')
        )
        imagemClasses.forEach((item) =>
          item.classList.remove('drop-acoes-menu-icone-ativado')
        )
      }
      elemento.classList.add('dropdown-desativado')
      elemento.classList.remove('dropdown-ativado')

      imagem.classList.add('drop-acoes-menu-icone-desativado')
      imagem.classList.remove('drop-acoes-menu-icone-ativado')
    }

    if (elemento.classList.contains('dropdown-ativado')) {
      if (classes.length > 0) {
        classes.forEach((item) => item.classList.add('dropdown-desativado'))
        classes.forEach((item) => item.classList.remove('dropdown-ativado'))

        imagemClasses.forEach((item) =>
          item.classList.add('drop-acoes-menu-icone-desativado')
        )
        imagemClasses.forEach((item) =>
          item.classList.remove('drop-acoes-menu-icone-ativado')
        )
      }
      classes.forEach((item) => item.classList.add('dropdown-desativado'))
      classes.forEach((item) => item.classList.remove('dropdown-ativado'))
    }
    setRenderizar(!renderizar)
  }

  return (
    <Form ref={modal} className="drop-acoes-container">
      <Button
        className="botao-filtros-acoes-cabecalho-sistema fundo-cor-7"
        data-place="bottom"
        onClick={() => {
          props.toggleRevelarDropAcoes(false)
        }}
      >
        <span
          className={`label-filtros-acoes-cabecalho-sistema ${
            props.titulo === 'Relatórios' ? 'margem-botao-relatorios' : ''
          } fonte-cor-1`}
        >
          {props.titulo}
        </span>
        <Image className="icone-acoes-cabecalho-sistema" src={setaDropdown()} />
      </Button>

      {spinAtivo ? (
        <>
          <div className="campo-select-triangulo-menor-cor-2" />
          <div className="campo-select-corpo fundo-cor-7 container-loader-acoes">
            <Loader />
          </div>
        </>
      ) : !currentMainAcoes ||
        !tempdesabilitarAcoesCliente ||
        !(acoes?.length > 0) ? (
        <>
          <div className="campo-select-triangulo-menor-cor-2" />
          <div disabled className="campo-select-corpo fundo-cor-7">
            <span className="fonte-cor-1 nenhuma-acao-encontrada-label">
              Selecione um item na tabela.
            </span>
          </div>
        </>
      ) : (
        <>
          <div className="campo-select-triangulo-menor-cor-2" />
          <div className="drop-acoes-corpo fundo-cor-7">
            <ul className="drop-acoes-lista-menu">{acoes}</ul>
          </div>
        </>
      )}
    </Form>
  )
})

DropAcoes.displayName = 'DropAcoes'

export default DropAcoes
